export function animatedTitle() {
        const animatedTitle = $('.animated-title');
        const wordsWrapParent = animatedTitle.find('.words-wrap');
        const wordsWrap = wordsWrapParent.find('span');
        const length = wordsWrap.length;
        let showedItem = wordsWrapParent.find('show');
        wordsWrapParent.find('span:last').addClass('show');

        wordAnimate();

        function wordAnimate() {
            showedItem = wordsWrapParent.find('.show');

            if (showedItem.index() !== length - 1) {
                showedItem.next().addClass('show');
                wordsWrapParent.css('width', showedItem.next().innerWidth())
                showedItem.removeClass('show');
            } else {
                wordsWrap.removeClass('show');
                wordsWrap.eq(0).addClass('show');
                wordsWrapParent.css('width', wordsWrap.eq(0).innerWidth())
            }

            setTimeout(wordAnimate, 3000);
        }
}


// WEBPACK FOOTER //
// ./assets/js/modules/animatedTitle.js